import { useEffect, useState } from "react";
import { navSections } from "@/mocks/feed";

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled || open
          ? "border-b border-background-200 bg-background-50/95 shadow-none backdrop-blur-md"
          : "border-b border-background-200/60 bg-background-50/70 backdrop-blur-sm"
      }`}
    >
      <div className="mx-auto flex h-16 max-w-[1320px] items-center justify-between px-4 md:px-6 lg:h-[72px]">
        {/* Brand */}
        <a href="#headline" className="flex items-center gap-2.5 whitespace-nowrap">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-fire-fill text-lg" aria-hidden="true"></i>
          </span>
          <span className="flex flex-col leading-none">
            <span className="font-heading text-xl font-black tracking-tight text-foreground-950 md:text-2xl">
              吃瓜<span className="text-primary-600">前线</span>
            </span>
            <span className="mt-1 hidden text-[10px] font-medium uppercase tracking-[0.28em] text-secondary-500 sm:block">
              最新爆料 · 事件追踪
            </span>
          </span>
        </a>

        {/* Desktop nav */}
        <nav className="hidden items-center gap-1 lg:flex" aria-label="主导航">
          {navSections.map((s) => (
            <a
              key={s.id}
              href={`#${s.id}`}
              className="whitespace-nowrap rounded-md px-3.5 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
            >
              {s.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <a
            href="#about"
            className="hidden whitespace-nowrap rounded-md bg-secondary-100 px-4 py-2 text-sm font-semibold text-secondary-900 transition-colors hover:bg-secondary-200 md:inline-flex"
          >
            线索投稿
          </a>
          <a
            href="#feed"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            去追更
          </a>
          {/* Mobile toggle */}
          <button
            type="button"
            onClick={() => setOpen((v) => !v)}
            aria-label={open ? "关闭菜单" : "打开菜单"}
            aria-expanded={open}
            className="flex h-10 w-10 cursor-pointer items-center justify-center rounded-md border border-background-200 text-foreground-800 transition-colors hover:bg-background-100 lg:hidden"
          >
            <i className={open ? "ri-close-line text-xl" : "ri-menu-line text-xl"} aria-hidden="true"></i>
          </button>
        </div>
      </div>

      {/* Mobile panel */}
      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 lg:hidden"
          aria-label="移动端导航"
        >
          <div className="mx-auto grid max-w-[1320px] grid-cols-2 gap-1 px-4 py-4 md:px-6">
            {navSections.map((s) => (
              <a
                key={s.id}
                href={`#${s.id}`}
                onClick={() => setOpen(false)}
                className="flex items-center justify-between rounded-md px-3 py-3 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100 hover:text-primary-600"
              >
                {s.label}
                <i className="ri-arrow-right-s-line text-secondary-400" aria-hidden="true"></i>
              </a>
            ))}
            <a
              href="#about"
              onClick={() => setOpen(false)}
              className="col-span-2 mt-1 flex items-center justify-center whitespace-nowrap rounded-md bg-secondary-100 px-4 py-3 text-sm font-semibold text-secondary-900"
            >
              <i className="ri-mail-send-line mr-2" aria-hidden="true"></i>线索投稿 / 联系我们
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}